import {Component, OnInit,  Input} from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter} from '../../@theme/pipes/dateFormatPicker';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import {  FormBuilder } from '@angular/forms';

@Component({
  selector: 'ngx-user-temas',
  templateUrl: './user-temas.component.html',
  styleUrls: ['./user-temas.component.scss'],
  providers: [UtilidadesService,PeticionesHttpBackEndService,NgbModalConfig, NgbModal,{provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}]
})
export class UserTemasComponent implements OnInit {
 
  Token: any;
  openModal:any;
  listadoTemas:any;
  usuario:any;
  nombreEditar:any;
  descripcionEditar:any;
  checkSociosEditar:any;
  nombreCrear:any;
  descripcionCrear:any;
  checkSociosCrear:any;
  tema:any;
  filtrarLista:any;
  listadoTemasFiltrado:any;
  foros:any;
  msgError:any;
  busquedaGeneral:any;
  busquedaActivada:boolean;
  @Input() foroId: any;
  @Input() navegacion:any;
  @Input() activarRastro:any;
  constructor(private datepip: DatePipe,private _route: ActivatedRoute, private utilidades: UtilidadesService,config: NgbModalConfig, private modalService: NgbModal, private _http : PeticionesHttpBackEndService, private DatePipe: DatePipe,public fb: FormBuilder,private router: Router) { 
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
    this._route.queryParams.subscribe(params => {
      this.foroId = params.foroId !== null ? params.foroId : this.foroId;
    });
    this.listadoTemas = [];
    this.listadoTemasFiltrado = [];
    config.backdrop = 'static';
    config.keyboard = false;
    this.navegacion = this.navegacion == false ? false : true;
    this.foros = null;
    this.msgError = false;
    this.activarRastro = this.activarRastro == false ? false : true;
    this.busquedaGeneral = "";
    this.busquedaActivada = false;

    
  }

  ngOnInit() {
    this._http.getUsuario().subscribe(
      result => {
        this.usuario = result;
        this._http.getOneReg("v1/getTemasForos",this.usuario.Entidad._entidad_id+"/"+this.foroId).subscribe(
          result => {
            let resultado:any = result;
            if(resultado.Code == 250){
              this.msgError = true;
              this.navegacion = false;
              this.utilidades.notificationWarning("Aviso","Debe aceptar los terminos LOPD de su pestaña social","top-left");
            }else{
              this.foros = resultado.Foros;
              this.listadoTemas = JSON.parse(JSON.stringify(resultado.Temas));
              this.listadoTemasFiltrado = JSON.parse(JSON.stringify(resultado.Temas));
              this.navegacion = true;
            }
          });
      }
    );

  }


  modalCrear(content) {
    this.openModal = this.modalService.open(content);
    this.nombreCrear = "";
    this.descripcionCrear = "";
    this.checkSociosCrear = "";
  }

  crearNuevoTema(){
    if((this.nombreCrear !== null  && this.nombreCrear !== undefined && this.nombreCrear.length > 0) && (this.descripcionCrear !== null  && this.descripcionCrear !== undefined && this.descripcionCrear.length > 0)){
      this._http.insertaObjecto("v1/solicitarNuevoTema",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"nombre":this.nombreCrear,"descripcion":this.descripcionCrear,
      "soloSocios":this.checkSociosCrear,"foroTemaId":null,"foroId":this.foroId,"eliminarTema":false}}).subscribe(
        result => {
          let resultado :any = result;
          if(resultado.Code == 200){
            this.openModal.close();
            this.utilidades.notificationSuccess("Aviso","El tema ha sido solicitado","top-left");
          }else{
            this.utilidades.notificationWarning("Aviso","Hubo un problema al solicitar el tema","top-left");
          }
        },
        error => {
        }
      );
    }else{
      this.utilidades.notificationWarning("Aviso","Debe rellenar los campos \"Nombre\" y \"Descripción\"","top-left");
    }
  }
   
  buscar(){
    this.listadoTemasFiltrado = JSON.parse(JSON.stringify(this.listadoTemas))
    if(this.filtrarLista !== ""){
      this.listadoTemasFiltrado = [];
      this.listadoTemas.forEach(element => {
        if((this.filtrar_acentos(element._nombre).indexOf(this.filtrar_acentos(this.filtrarLista)) !== -1) ||
        (this.filtrar_acentos(element._descripcion).indexOf(this.filtrar_acentos(this.filtrarLista)) !== -1)){
          this.listadoTemasFiltrado.push(element);
        }
      });
    }
  }
  filtrar_acentos(input){
    var acentos = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç";
    var original = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";
    for (var i = 0; i < acentos.length; i++) {
        input = input.replace(acentos.charAt(i), original.charAt(i)).toLowerCase();
    };
    return input;
}

navegarForo(id){
  let parametros: NavigationExtras = {
    queryParams: { 'foroId': id}
  };
  this.router.navigate(['private/user-subforos'],parametros);
}
navegarForoPrincipal(){
  this.router.navigate(['private/user-foros']);

}

abrirTema(evento){
  let parametros: NavigationExtras = {
    queryParams: { 'tema': evento._foro_tema_id,"f":this.foroId}
  };
  this.router.navigate(['private/foros-mensajes'],parametros);
}

onSearch(){
  let parametros: NavigationExtras = {
    queryParams: { 'nom': this.busquedaGeneral }
  };
  this.router.navigate(['private/buscador'], parametros);
}

buscarActivado(){
  this.busquedaActivada = !this.busquedaActivada;
}


  
}
